// extracted by mini-css-extract-plugin
export var container = "_8a-0";
export var error = "_8a-9";
export var label = "_8a-5";
export var light = "_8a-6";
export var md = "_8a-3";
export var sm = "_8a-2";
export var thin = "_8a-8";
export var thinBold = "_8a-7";
export var vertical = "_8a-4";
export var xs = "_8a-1";